import axiosInstance from "../../../core/api/interceptors/axiosInterceptor";

export const fetchDashboardData = async (dateRange, documentType = 'all') => {
  const params = {
    startDate: dateRange.startDate,
    endDate: dateRange.endDate,
  };
  
  // Add document type filter if not 'all'
  if (documentType && documentType !== 'all') {
    params.documentType = documentType;
  }
  
  const response = await axiosInstance.get(`/dashboard`, { params });
  return response.data;
};